<ng-template #header>
    <shared-vcard-for-common preTitleMarginTop="xlg" [preTitle]="preTitle">
        {{title}}
    </shared-vcard-for-common>
</ng-template>

<shared-modal-type-dynamic-height [header]="header" [headerBorderBottom]="false" [size]="size" [modalData]="modalData"
    [center]="true" size="sm" (onCloseClick)="handleCloseClick($event)" class="modal-for-credit-card-add">

    <div class="modal-for-credit-card-add__content">

        <shared-form-for-payment-method *ngIf="isCommonType" [labelSubmit]="labelSubmit" [compact]="true"
            (onFormSubmit)="handleFormSubmit($event)" [delay]="delay" [guest]="false" [modal]="true">
        </shared-form-for-payment-method>

        <shared-form-for-payment-method-redirect *ngIf="isRedirectType" [labelSubmit]="labelSubmit" [compact]="true"
            (onFormSubmit)="handleFormSubmit($event)" [delay]="null" [guest]="false" [modal]="true">
        </shared-form-for-payment-method-redirect>

        <shared-form-for-payment-method-from-provider *ngIf="isProviderFormType" [labelSubmit]="labelSubmit"
            [compact]="true" (onFormSubmit)="handleFormSubmit($event)" [delay]="null" [guest]="false" [modal]="true">
        </shared-form-for-payment-method-from-provider>

    </div>

</shared-modal-type-dynamic-height>
